<template>
    <span class="badge-pill badge-success"
          :class="category">{{ displayName }}</span>
</template>

<script>
export default {
  props: {
    category: String
  },
  computed: {
    displayName() {
      if ('RES' === this.category)
        return 'Erlebnis'
      if ('REN' === this.category)
        return 'Leihe'
      if ('VOU' === this.category)
        return 'Gutschein'
      if ('FOO' === this.category)
        return 'Catering'
      if ('WEL' === this.category)
        return 'Wellness'
      if ('PER' === this.category)
        return 'zus. Person'
      return '?'
    }
  }
}
</script>

